import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContactService } from '../services/contact.service';

@Injectable()
export class EditContactResolver {
  constructor(private contactService: ContactService) { }

  resolve(route: ActivatedRouteSnapshot) {
    return this.contactService.getContact(route.params.lcAuto);
  }
}
